import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { useContext, useState } from 'react';

export const useDropdown = () => {
    //Work around
    const [triggerRender, setTriggerRender] = useState(false);
    // Function to trigger a re-render
    const handleTriggerRender = () => {
        setTriggerRender(prevState => !prevState);
    };
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);
    const { playButtonAudio } = useContext(AudioPlayContext);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        playButtonAudio();
        setAnchorEl(event.currentTarget);
        setTimeout(() => {
            handleTriggerRender();
        }, 10);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return {
        triggerRender,
        anchorEl,
        open,
        handleOpen,
        handleClose,
    };
};
export type useDropdownState = ReturnType<typeof useDropdown>;
